<template>
	<div class="wrapper">
		<global-state-aggregator-oro-watcher
			v-for="(oro, oroIndex) in oros"
			:key="`raw-oro::${oro.$internals.metaProperties.meta.guid}`"
			:ORO="oro"
			@triggerReCalc="triggerReCalc" />
	</div>
</template>
<script>
import GlobalStateAggregatorORO from "js/data-store/state-management/global-state-aggregator-oro.js";
import GlobalStateAggregatorOroWatcher from "vue/sheet-views/common/global-state-aggregators/global-state-aggregator-oro-watcher.vue";

export default {
	created() {
		GlobalStateAggregatorORO.init(); // Even if this was created before, just re initialize it to remove any nulls
	},
	destroyed() {
		GlobalStateAggregatorORO.init(); // Remove all stale wom references to avoid future data collisions if the user changes workbook
	},
	watch: {
		oros: {
			immediate: true,
			handler(OROs, previousOROs) {
				this.triggerReCalc();
			}
		}
	},
	components: {
		GlobalStateAggregatorOroWatcher
	},
	props: {
		dataStore: {
			required: false
		}
	},
	methods: {
		setStructure() {
			if (this.structuredRequirements.records) {
				GlobalStateAggregatorORO.setStructure(this.structuredRequirements);
			}
		},
		triggerReCalc() {
			if (this.dataStore) {
				this.setStructure();
				GlobalStateAggregatorORO.populate({ OROs: this.oros, dataStore: this.dataStore });
			}
		}
	},
	computed: {
		structuredRequirements() {
			return {
				records: this.dataStore ? this.dataStore.records : null,
				fields: this.dataStore ? this.dataStore.meta.schema.fields : null
			}
		},
		oros() {
			// Grab a handle to our datastore
			const dataStore = this.$root.systemState.applicationData.activeWorkbook.dataStore;
			const cmo = this.$root.systemState.auth.organization
				? this.$root.systemState.auth.organization.connectionsManifestObject
				: null;
			// Extract the oros from the dataStore and return them sorted in order triggered
			let OROs = [];
			let OROsGUIDMap = {};
			if (dataStore !== null) {
				OROs.push(...dataStore.OROs);
				OROs.forEach(function withORO(oro) {
					OROsGUIDMap[oro.$internals.metaProperties.meta.guid] = true;
				});
			}
			if (cmo !== null) {
				cmo.OROs.forEach(function withORO(oro) {
					if (!OROsGUIDMap[oro.$internals.metaProperties.meta.guid]) {
						OROs.push(oro);
						OROsGUIDMap[oro.$internals.metaProperties.meta.guid] = true;
					}
				});
			}
			OROs = OROs.sort(function compareDateBegan(oroA, oroB) {
				return oroA.$internals.metaProperties.meta.dateCreated.getTime() - oroB.$internals.metaProperties.meta.dateCreated.getTime();
			});
			return OROs;
		}
	}
}
</script>
<style lang="scss" scoped>
div.wrapper {
	display: none;
}
</style>